import axios from 'axios';
import HttpService from "@/utils/httpData"
let loginInfo = $cookies.get('login-info');
let token = '';
if (loginInfo != null && loginInfo.accessToken != null) {
    token = loginInfo.accessToken;
}

export const HTTP = axios.create({
    baseURL: 'http://45.118.144.25:8025/api/',
    headers: {
        'Accept': 'application/json',
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + token
    }
})


export const HTTPExport = axios.create({
    baseURL: 'http://45.118.144.25:8025/api/',
    headers: {
        'Accept': 'application/pdf',
        'Authorization': 'Bearer ' + token
    },
    responseType: 'blob'
})
